<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="邀请入职"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       
        <el-form-item label="职位信息" prop="job_id" >  
           <el-select
                v-model="selectedJob" 
                placeholder="请选择入职职位"
                clearable
                filterable
                style="width:100%"
                value-key="job_id"
                @change="selectJob"
              >
              <el-option
                v-for="item in jobList"
                :key="item.job_id"
                :label="item.title"
                :value="item"
              />
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间" prop="check_time" >  
          <el-date-picker
            v-model="formData.check_time"
            type="datetime"
            placeholder="请选择入职时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="联系方式	" prop="mobile" >
          <el-input  type="number" v-model="formData.mobile" placeholder="请输入联系方式"></el-input>
        </el-form-item>


        <el-form-item label="地址信息	" prop="j_address_id" >
          <el-select
                v-model="selectedAddress" 
                placeholder="请选择入职地址"
                clearable
                filterable
                style="width:100%"
                value-key="j_address_id"
                @change="selectAddress"
              >
              <el-option
                v-for="item in addressList"
                :key="item.j_address_id"
                :label="item.address"
                :value="item"
              />
          </el-select>
        </el-form-item>


        <el-form-item label="入职通知" prop="mark">
          <el-input 
          type="textarea" 
          v-model="formData.mark"  
          :rows="4"
            placeholder="输入入职通知"></el-input>
        </el-form-item>
       
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { jobList,addressAdd} from "@/api/chat/index";

export default {
  components: { },

  data() {
    return {
      visible: false,
      jobList:[],
      selectedJob:null,
      selectedJob:{},
      selectedAddress:{},
      addressList:[],
      formData: {
        user_app_id:"",
        check_time: "",
        job_id:"",
        mobile:"",
        j_address_id: "",
        address:"",
        mark:''
       
      },
       rules: {
        check_time: [
              {required: true, message: '请选择入职时间', trigger: 'blur'}
          ],
          job_id: [
              {required: true, message: '请选择职位', trigger: 'blur'}
          ],
          mobile: [
              {required: true, message: '请输入联系方式', trigger: 'blur'}
          ],
          j_address_id: [
              {required: true, message: '请输入入职地址', trigger: 'blur'}
          ],
          mark: [
              {required: true, message: '请输入入职通知', trigger: 'blur'}
          ]

       }
    };
  },

 
  mounted() {

},
destroyed(){

},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.selectedJob=null;
      this.selectedJob={};
      this.selectedAddress={};
      this.addressList=[];
      this.visible = false;

    },


    init(user_app_id) {
      console.log(user_app_id);
      this.visible = true;
      this.formData.user_app_id=user_app_id;
      
      this.initJobList();
    },

    initJobList(){
      var that = this;
      jobList({}).then((response) => {
        that.jobList = response.data;
      });
    },
    
    selectJob(e){
      this.selectedJob=e;
      console.log("selectJob",e);
      if(e){
        this.formData.job_id=e.job_id;
        this.addressList=e.address;
      }
    },
    selectAddress(e){
      this.selectedAddress=e;
      this.formData.j_address_id=e.j_address_id;
      
    },
    submit(){
      var that=this;
      this.$refs["form"].validate((valid) => {
          if (valid) {
            addressAdd(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
               var enroll_id=response.enroll_id;
                that.$emit('callback',18,enroll_id);
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          }
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
